import { render, staticRenderFns } from "./nav-title.vue?vue&type=template&id=6a7c1ce0&scoped=true&"
import script from "./nav-title.vue?vue&type=script&lang=js&"
export * from "./nav-title.vue?vue&type=script&lang=js&"
import style0 from "./nav-title.vue?vue&type=style&index=0&id=6a7c1ce0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7c1ce0",
  null
  
)

export default component.exports